export default __webpack_public_path__ + "static/image_about-55c7dd4b9936ff630e41bc8c87ad6236.jpg";